<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <div class="overflow-auto">      
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="align-middle">
              Nombre del producto
            </th>
            <th scope="col" class="align-middle">
              Base Imponible
            </th>
            <th scope="col" class="align-middle">
              CUOTA NETA
            </th>
            <th scope="col" class="align-middle">
              IVA
            </th>
            <th scope="col" class="align-middle">
              CUOTA BRUTA
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="justify-content-center" v-for="(element, index) in product.products" v-bind:key="index">
            <td class="align-middle">{{ element.name }}</td>
            <td class="align-middle">{{ element.totalMonthlyNetFee }}</td>
            <td class="align-middle">{{ element.totalFeeTaxFree }}</td>
            <td class="align-middle">{{ element.totalTax }}</td>
            <td class="align-middle">{{ element.totalFee }}</td>
          </tr>
          <tr class="justify-content-center">
            <td class="align-middle"><strong>TOTAL: </strong></td>
            <td class="align-middle"><strong>{{ product.totalMonthlyNetFee }}</strong></td>
            <td class="align-middle"><strong>{{ product.totalFeeTaxFree }}</strong></td>
            <td class="align-middle"><strong>{{ product.totalTax }}</strong></td>
            <td class="align-middle"><strong>{{ product.totalFee }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 d-flex justify-content-between p-0">
      <div><button class="btn generalTertiaryButton" data-dismiss="modal">Cerrar</button></div>
      <button class="btn btn-primary generalPrimaryButton" data-dismiss="modal" @click="contratar()">Contratar</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../../Shared/Modal.vue';
export default {
  name: 'CalculateModal',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'product',
    'submit'
  ],
  components: {
    Modal,
  },
  data() {
    return {
      classes: this.class,
    }
  },
  methods: {
    contratar() {
      this.$emit('submit')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"></style>
